import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'

export const NewDialog = ({ open, setOpen }: BaseProps) => {
  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>New venue</DialogTitle>
        <DialogBody>
          <NewForm onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
